import React, { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { bulkUpdate, notificationPreferences, updateNotificationPreference } from "../../../redux/slices/notificationSlice";
import { FiX } from "react-icons/fi";

const JobsNotificationModal = ({ show, onHide, category }) => {
  const { notificationPreferencesItems } = useSelector(
    (state) => state.notification
  );
  const dispatch = useDispatch();
  const [allEnabled, setAllEnabled] = useState(true);
  const [settings, setSettings] = useState({
    email_enabled: true,
    push_enabled: true,
    in_app_enabled: true
  });
 const handleAllToggle = async () => {
  const updatedValue = !allEnabled;
  setAllEnabled(updatedValue);

  // Update local settings state
  const updatedSettings = {
    email_enabled: updatedValue,
    push_enabled: updatedValue,
    in_app_enabled: updatedValue
  };
  
  setSettings(updatedSettings);

  // Create bulk update payload with only the current category
  const payload = {
    preferences: [
      {
        category: category,
        email_enabled: updatedValue,
        push_enabled: updatedValue,
        in_app_enabled: updatedValue
      }
    ]
  };

  // Call bulk update API
  await dispatch(bulkUpdate(payload));

  // Reload preferences from API
  dispatch(notificationPreferences());
};
  const handleToggle = (type) => {

  const updatedSettings = {
    ...settings,
    [type]: !settings[type]
  };

  setSettings(updatedSettings);

  // check if all toggles are enabled
  const isAllEnabled =
    updatedSettings.email_enabled &&
    updatedSettings.push_enabled &&
    updatedSettings.in_app_enabled;

  setAllEnabled(isAllEnabled);

  dispatch(
    updateNotificationPreference({
      category,
      payload: updatedSettings
    })
  );
};
  useEffect(() => {
    if (notificationPreferencesItems?.data) {

      const categoryData = notificationPreferencesItems.data.find(
        (item) => item.category === category
      );

      if (categoryData) {

        setSettings({
          email_enabled: categoryData.email_enabled,
          push_enabled: categoryData.push_enabled,
          in_app_enabled: categoryData.in_app_enabled
        });

        // Check if all toggles are enabled for THIS category only
        const isAllEnabled =
          categoryData.email_enabled &&
          categoryData.push_enabled &&
          categoryData.in_app_enabled;

        setAllEnabled(isAllEnabled);
      }
    }
  }, [notificationPreferencesItems, category]);
  useEffect(() => {
    if (show) {
      dispatch(notificationPreferences());
    }
  }, [show, dispatch]);
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="md"
      dialogClassName="custom-modal profile-other-details-modal"
    >


      <Modal.Header>
        <h5 className="modal-title">Jobs Notification Settings</h5>
        <Button className="close-btn" onClick={onHide}>
          <FiX size={24} />
        </Button>
      </Modal.Header>

      <Modal.Body className="pt-3">

        <div className="d-flex justify-content-between align-items-center py-2 border-bottom">
          <span className="fw-medium">Enable All Notifications</span>

          <Form.Check
            type="switch"
            id="all-switch"
            checked={allEnabled}
            onChange={handleAllToggle}
          />
        </div>

        <div className="d-flex justify-content-between align-items-center py-2 border-bottom">
          <span className="fw-medium">Email</span>

          <Form.Check
            type="switch"
            id="email-switch"
            checked={settings.email_enabled}
            onChange={() => handleToggle("email_enabled")}
          />
        </div>

        <div className="d-flex justify-content-between align-items-center py-2 border-bottom">
          <span className="fw-medium">Push</span>

          <Form.Check
            type="switch"
            id="push-switch"
            checked={settings.push_enabled}
            onChange={() => handleToggle("push_enabled")}
          />
        </div>

        <div className="d-flex justify-content-between align-items-center py-2">
          <span className="fw-medium">In App</span>

          <Form.Check
            type="switch"
            id="inapp-switch"
            checked={settings.in_app_enabled}
            onChange={() => handleToggle("in_app_enabled")}
          />
        </div>

      </Modal.Body>

    </Modal>
  );
};

export default JobsNotificationModal;